export default __webpack_public_path__ + "static/media/eshdc.8972f760.svg";